import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Footer from '~/components/Footer';
import Menu from '~/components/Menu';
import { Container } from '~/styles/pagesStyle';
import Card from './Card';

function Home() {
  const [loading, setLoading] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const [modal, setModal] = useState(true);
  const toggle = () => setModal(!modal);
  const { userName } = useSelector((state) => state.Grupos);
  const [form, setForm] = useState({});
  return (
    <Container>
      <Footer />
      <Menu />
      <Card
        modal={modal}
        toggle={toggle}
        loading={loading}
        isSelected={isSelected}
        setIsSelected={setIsSelected}
        setLoading={setLoading}
        nomeUser={userName}
        setForm={setForm}
        form={form}
      />
    </Container>
  );
}

export default Home;
